<div class="map-legend">
  <div class="legend-details" [ngClass]="{ 'toggle-legend': legendExpanded }">
    <div class="legend-types">
      @if (!isOrv) {
        <div class="description">
          <div i18n>Trunk</div>
          <div>
            <img alt="Trunk" [ngSrc]="trunkImg" i18n-alt />
          </div>
        </div>
        <div class="description">
          <div i18n>Trail</div>
          <div>
            <img alt="Trail" [ngSrc]="trailImg" i18n-alt />
          </div>
        </div>
        <div class="description">
          <div i18n>Club Trail</div>
          <div>
            <img alt="Cub Trail" [ngSrc]="clubTrailImg" i18n-alt />
          </div>
        </div>
        <div class="description">
          <div i18n>Unmaintained</div>
          <div>
            <img alt="Unmaintained" [ngSrc]="unmaintainedImg" i18n-alt />
          </div>
        </div>
        <div class="description">
          <div i18n>Closed</div>
          <div>
            <img alt="Closed" [ngSrc]="closedImg" i18n-alt />
          </div>
        </div>
      } @else {
        <div>
          <img
            class="type"
            alt="All Vehicle"
            aria-label="All Vehicles"
            ngSrc="/assets/icons/allvehicles.svg"
            i18n-alt
            i18n-aria-label
          />
        </div>
        <div class="description">
          <div i18n>Any</div>
          <div>
            <img alt="Any" [ngSrc]="otherLineImg" i18n-alt />
          </div>
        </div>
        <div>
          <img
            class="type"
            alt="side by side"
            aria-label="side by side"
            ngSrc="/assets/icons/rov.svg"
            i18n-alt
            i18n-aria-label
          />
        </div>
        <div class="description">
          <div i18n>SxS</div>
          <div>
            <img alt="side by side" [ngSrc]="rovLineImg" i18n-alt />
          </div>
        </div>
        <div>
          <img
            class="type"
            alt="side by side < 50"
            aria-label='side by side < 50"'
            ngSrc="/assets/icons/rov50.svg"
            i18n-alt
            i18n-aria-label
          />
        </div>
        <div class="description">
          <div i18n>SxS<50"</div>
          <div>
            <img alt='side by side < 50"' [ngSrc]="rov50LineImg" i18n-alt />
          </div>
        </div>
        <div>
          <img class="type" alt="ATV" aria-label="ATV" ngSrc="/assets/icons/atv.svg" i18n-alt i18n-aria-label />
        </div>
        <div class="description">
          <div i18n>ATV</div>
          <div>
            <img alt="ATV" [ngSrc]="atvLineImg" i18n-alt />
          </div>
        </div>
        <div>
          <img
            class="type"
            alt="Dirt Bike"
            aria-label="Dirt Bike"
            ngSrc="/assets/icons/ohm.svg"
            i18n-alt
            i18n-aria-label
          />
        </div>
        <div class="description">
          <div i18n>Dirt Bike</div>
          <div>
            <img alt="Dirt Bike" [ngSrc]="ohmLineImg" i18n-alt />
          </div>
        </div>
      }

      <div class="heat-map-label" i18n>Open Area w/ heatmap</div>
      <div class="description open-area-description">
        <div>
          <img class="ride-area-icon" alt="Open Ride Area" [ngSrc]="openRideAreaImg" i18n-alt />
        </div>
      </div>
      <div class="other-types-container">
        @if (isOrv) {
          <div class="other-types">
            <img alt="Designated Route Paved" [ngSrc]="designatedPavedImg" i18n-alt />
            <img alt="Designated Route Unpaved" [ngSrc]="designatedUnpavedImg" i18n-alt />
            <img alt="closed" ngSrc="/assets/icons/map-legend-icons/icon-closed-trail.svg" i18n-alt />
          </div>
        }
      </div>
      <a id="mapLegendHelp" class="help-icon" href="javascript:void(0);" (click)="openMapLegend()">
        <svg-icon src="/assets/icons/help.svg" svgAriaLabel="help" i18n-svgAriaLabel />
      </a>
      <a id="mapLegendClose" class="close-icon description" href="javascript:void(0);" (click)="setLegendExpandedOff()">
        <svg-icon src="/assets/icons/close.svg" svgAriaLabel="close" i18n-svgAriaLabel />
      </a>
    </div>
  </div>

  <a
    id="mapLegendBtn"
    class="button toggle-label"
    href="javascript:void(0);"
    [ngClass]="{ 'toggle-legend': legendExpanded }"
    (click)="toggleLegendExpanded()"
    i18n
    >Legend</a
  >
</div>
